// src/views/auth/_shared/types.ts
// Shared types for the auth surface.

export type ErrorVariant =
  | 'expired-link'
  | 'invalid-link'
  | 'locked'
  | 'suspended'
  | 'rate-limited'
  | 'session-expired'
  | 'generic';

export type BrandPanelKind = 'equation' | 'paper' | 'lml';

export type BrandPanelSurface = 'paper' | 'indigo' | 'neutral';

export type SocialProvider = 'google' | 'github' | 'sso';

/**
 * Session duration we hand to Stytch on every authenticate / create call.
 * Locked to one week per D2 in 03-answers-from-oussama.md.
 */
export const SESSION_MINUTES = 60 * 24 * 7;

/**
 * Verification + reset link lifetime, surfaced in copy so we don't lie to
 * users. Match Stytch project settings.
 */
export const LINK_EXPIRY_MINUTES = 30;

/**
 * Social-provider gate. False = hide the Google / GitHub buttons + the
 * "or continue with email" divider from sign-in and sign-up.
 *
 * Flip to true once:
 *   1. Google + GitHub OAuth clients are configured in Stytch
 *      (Stytch dashboard → Configuration → OAuth → Configure provider)
 *   2. Google Cloud Console + GitHub OAuth Apps have Stytch's
 *      redirect URIs added to their allow-lists
 */
export const SOCIAL_PROVIDERS = {
  // 17 Oct 2026: OAuth allowed in Stytch's SDK; Google configured (Stytch's default credentials).
  google: true,
  // Needs a GitHub OAuth app, its client id and secret in Stytch → Configuration → OAuth → GitHub.
  github: false,
} as const;

/** Test builds sign in without Stytch (the test copy's people), so no social buttons there. */
export const SOCIAL_PROVIDERS_ENABLED = !import.meta.env.VITE_E2E && (SOCIAL_PROVIDERS.google || SOCIAL_PROVIDERS.github);
